import { api } from '@/api'
import { page } from '@garpix/fetcher/fetcher/storeon'
import { ModalType } from '@/types/modal'

interface IStoreModal {
  showModal?: null | ModalType
  modalProps?: any
}

const user = (store): void => {
  store.on('@init', () => ({ currentUser: null }))
  store.on('user/save', ({ currentUser }, user) => ({
    currentUser: { ...currentUser, ...user }
  }))
  store.on('user/get', async (_, { callback }) => {
    try {
      const token = api.getAuthToken()
      if (token === null) {
        throw new Error()
      }
      const data = await api.getCurrentUser()
      store.dispatch('user/save', {
        ...data,
        status: true
      })
      if (callback !== undefined) {
        callback()
      }
    } catch (e) {
      store.dispatch('user/save', { status: false })
      if (callback !== undefined) {
        callback()
      }
    }
  })
}

const modal = (store): void => {
  store.on('@init', () => ({ showModal: null }))
  store.on(
    'modal/toggle',
    (
      _: any,
      { modal, modalProps }: { modal: ModalType, modalProps: any }
    ): IStoreModal => ({
      showModal: modal,
      modalProps: modalProps
    })
  )
  store.on('modal/close', () => ({ showModal: null }))
}

export const storeonParams = [page, user, modal]
